import {CommonMessages} from '../common.messages';

export const AddBankAccountMessages = {
    UploadStatementFailed: {
        key: 'UploadStatementFailed',
        message: 'Error while request to the server. Unable to upload bank statement.'
    },
    CreateBankAccountFailed: {
        key: 'CreateBankAccountFailed',
        message: 'Error while request to the server. Unable to create bank account.'
    },
    GetBankAccountFailed: {
        key: 'GetBankAccountFailed',
        message: 'Error while request to the server. Unable to get newly created bank account.'
    },
    BankAccountSuccessfullyCreated: {
        key: 'BankAccountSuccessfullyCreated',
        message: 'Bank account is successfully created.'
    },
    ...CommonMessages
};
